import { api } from "@/lib/api";
import { logError } from "@/lib/log";

// Guest payment claim lives in an HttpOnly cookie set by the server; JS never stores the token.
export const rememberClaim = (token) => api.post("/payments/claim/remember", { claim_token: token }).then((r) => r.data);
const LEGACY_KEY = "mm_claim";

// one-time move of a token saved by older versions into the cookie
let migration;
const migrateLegacy = () => (migration ||= (async () => {
  const raw = localStorage.getItem(LEGACY_KEY);
  if (!raw) return;
  localStorage.removeItem(LEGACY_KEY);
  try { await rememberClaim(JSON.parse(raw).token); } catch (e) { logError("Legacy claim migration skipped", e); }
})());

export const getClaim = async () => {
  await migrateLegacy();
  return api.get("/payments/my-claim").then((r) => (r.data.valid ? r.data : null)).catch(() => null);
};
